import jsCookie from 'js-cookie'

const getValueFromCookie = (cookie, value) => {
  const cookieValue = jsCookie.getJSON(cookie)

  if (typeof cookieValue === 'object' && cookieValue[value]) {
    return cookieValue[value]
  }

  if (typeof cookieValue === 'string') {
    const decodedCookieValue = JSON.parse(decodeURIComponent(cookieValue))

    if (decodedCookieValue && decodedCookieValue[value]) {
      return decodedCookieValue[value]
    }
  }

  return null
}

export { getValueFromCookie }
